import {
    Component,
    Input, TemplateRef, ViewChild,
} from '@angular/core';
import { MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';
import { NgIf } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';

@Component({
    selector: 'app-tp-snackbar',
    templateUrl: './snackbar.component.html',
    styleUrl: './snackbar.component.scss',
    imports: [
        NgIf,
        MatIcon,
        MatIconButton,
    ],
})
export class SnackbarComponent {
    /**
     * Reference to template
     */
    @ViewChild(TemplateRef, { static: true }) template!: TemplateRef<any>;

    /**
     * Snackbar type
     */
    @Input() type: 'success' | 'warning' = 'success';

    /**
     * Custom duration of snackbar in ms. Defaults to -1.
     * A value of -1 keeps the snackbar open until user manually closes.
     */
    @Input() duration = 3000;

    /**
   * Message to display in snackbar in stead of projected content
   */
    @Input() message?: string;

    /**
     * Reference to created snackbar. Used to close snackbar when user presses the 'x' button
     */
    snackBarRef?: MatSnackBarRef<any>;

    constructor(private snackBar: MatSnackBar) {}

    /**
     * Opens snackbar
     */
    open(): void {
        this.snackBarRef = this.snackBar.openFromTemplate(this.template, { duration: this.duration });
    }
}
